module.exports = " <div class=hidden-input> <input v-bind:id=field.name type=hidden v-model=field.value v-bind:name=field.name /> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/inputs/HiddenInput.vue
// module id = 732
// module chunks = 2